import React, {useState} from "react";
import SavedPresetsList from "./SavedPresetsList";
import FocusedPresetsForm from "./FocusedPresetsForm";
import CustomPresetsPreview from "./CustomPresetsPreview";
import {OutlinedButton} from "components/CustomButton";
import CustomIcon from "components/CustomIcon";
import {FOCUS_DISPLAY_TYPE, FOCUS_ITEM_STYLE, FOCUS_ITEM_STYLE_LIST} from "../enums";
import {RadioItem} from "../../../components/form/RadioGroup";
import CustomTab from "components/tab/CustomTab";
import TabGroup from "components/tab/TabGroup";

const FocusedCustomPresets = ({preset, setPreset, editing = false, isFocused = true, presets}) => {

  const [isEdit, setIsEdit] = useState(false);
  const [isPreviewing, setIsPreviewing] = useState(false);

  return (
    <div className="border p-4 rounded-md mb-4">
      <div className="flex items-center justify-between border-b-2 border-dashed pb-4">
        <div className="text-lg">Aspect Ratio</div>
        <div className="flex items-center text-xs space-x-2.5 md:mb-0">
          {isFocused && <div className="flex items-center text-xs space-x-4 md:mb-0">
                <TabGroup inline={false} extClass="mb-0">{FOCUS_ITEM_STYLE_LIST
                    .map((o) => (
                      <CustomTab key={`${o.value}_styles`} 
                      onClick={editing ? null : () => setPreset({...preset, style: o.value})}
                      className="px-6 py-2.5 whitespace-nowrap"
                      disabled={!(o.value === preset.style || (!preset.style && o.value === FOCUS_ITEM_STYLE.normal)) && editing}
                      // disabled={!!showModal?.edit || (isProductType && o === FOCUS_DISPLAY_TYPE[2])}                
                      active={o.value === preset.style || (!preset.style && o.value === FOCUS_ITEM_STYLE.normal)}
                      >{o.label}</CustomTab>
                    ))}
                </TabGroup>
              </div>
            }
          <div className="flex space-x-2 justify-end">
            <OutlinedButton isIconButton={true} onClick={() => setIsPreviewing(!isPreviewing)} title="Preview">
              <CustomIcon icon="visibility"/>
            </OutlinedButton>
            {!editing &&
              <SavedPresetsList setPreset={setPreset} presets={presets} preset={preset}/>
            }
          </div>   
        </div>       
      </div>
      {isPreviewing && <CustomPresetsPreview preset={preset}/>}      
      <FocusedPresetsForm preset={preset} setPreset={setPreset} isEdit={isEdit} setIsEdit={setIsEdit}
                          isFocused={isFocused} disabled={editing}/>
    </div>
  );
};

export default FocusedCustomPresets;
